export default __webpack_public_path__ + "static/media/illustrator.5b3f11d2.png";